import { ContainerModule } from '@patsnap/tahiti-core/shared/inversify';
import {
    AgenticSearchApi,
    AgenticSearchApiImpl,
    TechMindApi,
    TechMindApiImpl,
} from './apis/agentic-search-api';

export const agenticSearchContainer = new ContainerModule((bind) => {
    bind(AgenticSearchApi).to(AgenticSearchApiImpl);
    bind(TechMindApi).to(TechMindApiImpl);
});
